import user from "../../../assets/images/single_bill.svg";
import TitleValueWidget from "../../../components/trade_value_widget/TitleValueWidget";
import { useSelector } from "react-redux";
import { TRootState } from "../../../store";
import moment from "moment";
import DocumentsComponent from "../../../components/documents_view/document_viewer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import exclamatory from "../../../assets/images/pending_status.svg";
import {
  getCurrencyNumberWithSymbol,
  getMaskedMobileNumber,
} from "../../../helpers/get-currency-number";
import ConfirmReceiptArrival from "./ConfirmReceiptArrival";

const TransportPmtHistoty = () => {
  const { tradeDetailsById } = useSelector((state: TRootState) => ({
    tradeDetailsById: state.tradeDetailsById.tradeDetailsbyId,
  }));

  const transportationAmounts = tradeDetailsById?.destPmtHistory
    ?.filter((doc: any) => doc.pmtStatus !== "CANCELLED" && doc.pmtType === "TRANSPORTATION")
    ?.reduce((sum, doc) => sum + (doc.amount || 0), 0);

  const actualPaid =
    tradeDetailsById?.freightDtls?.paidTo === 'ONO' ?
      Number(transportationAmounts) + Number(tradeDetailsById?.lbrCharges) :
      Number(tradeDetailsById?.freightDtls?.freightPaid) + Number(tradeDetailsById?.lbrCharges);

  const amount = Number(tradeDetailsById?.lbrCharges) + Number(transportationAmounts);


  const paidAmt = tradeDetailsById?.freightDtls?.paidTo === 'ONO' ?
    Number(transportationAmounts) :
    Number(tradeDetailsById?.freightDtls?.freightPaid)

  return (
    <>
      {tradeDetailsById?.freightDtls?.destDriverName !== "" && (
        <div className="flex pb-2 bg-white outlet_padding border rounded-lg m-4">
          <img src={user} className="w-12 h-12 br-100" alt="" />
          <div className="ml-2 flex flex-col">
            <span className="font-semibold fs-14">
              {tradeDetailsById?.freightDtls?.destDriverName}
            </span>
            <span className="fs-12 color-sub-text">
              Driver-
              {getMaskedMobileNumber(
                tradeDetailsById?.freightDtls?.destDriverMobile
              )}
            </span>
          </div>
        </div>
      )}

      <div className="border rounded bg-white outlet_padding m-4">
        <div className="flex w-full gap-4">
          <TitleValueWidget
            title="Truck Number"
            value={tradeDetailsById?.freightDtls?.destVehNum ?? ""}
            classes="w-[30%]"
          />

          <TitleValueWidget
            title="Amount Paid"
            value={tradeDetailsById?.freightDtls?.paidTo === 'ONO' ?
              getCurrencyNumberWithSymbol(transportationAmounts) :
              getCurrencyNumberWithSymbol(tradeDetailsById?.freightDtls?.freightPaid, true)}
            classes="w-[30%]"
          />

          <div className="flex flex-col w-[33%]">
            <span className="fs-12 color-sub-text">Payment Status</span>
            <div className="flex flex-col w-[30%]">
              {/* {tradeDetailsById?.freightDtls?.pmtStatus === "ACCEPTED" && (
                <div className="flex items-center">
                  <CheckCircleIcon className="color-primary w-2 h-2" />
                  <span className="fs-14 color-primary ml-2">Approved</span>
                </div>
              )}

              {tradeDetailsById?.freightDtls?.pmtStatus === "PENDING" && (
                <div className="flex items-center">
                  <img src={exclamatory} className="w-5 h-5" alt="" />
                  <span className="fs-14 color-orange ml-2">Pending</span>
                </div>
              )} */}

              {tradeDetailsById?.freightDtls?.paidTo !== 'ONO' ? (
                <>
                  {tradeDetailsById?.freightDtls?.pmtStatus === "ACCEPTED" && paidAmt !== 0 ? (
                    <div className="flex items-center">
                      <CheckCircleIcon className="color-primary w-2 h-2" />
                      <span className="fs-14 color-primary ml-2">Approved</span>
                    </div>
                  ) : tradeDetailsById?.freightDtls?.pmtStatus === "PENDING" && paidAmt !== 0 ? (
                    <div className="flex items-center">
                      <img src={exclamatory} className="w-5 h-5" alt="" />
                      <span className="fs-14 color-orange ml-2">Pending</span>
                    </div>
                  ) : (
                    <span className="fs-14 text-gray-400">-</span>
                  )}
                </>
              ) : (
                <>
                  {paidAmt !== 0 ? (
                    <div className="flex items-center">
                      <CheckCircleIcon className="color-primary w-2 h-2" />
                      <span className="fs-14 color-primary ml-2">Approved</span>
                    </div>
                  ) : (
                    <span className="fs-14 text-gray-400">-</span>
                  )}
                </>
              )}
              {/*  {tradeDetailsbyId?.freightDtls?.pmtStatus === 'CANCELLED' && (
                                                <div className="flex items-center">
                                                  <HighlightOffTwoToneIcon className=" color-red w-4 h-4" />
                                                  <span className="fs-14 color-red ml-2">
                                                    Cancelled
                                                  </span>
                                                </div>
                                              )} */}
            </div>
          </div>
        </div>

        <div className="pt-2 border-b"></div>

        <div className="flex w-full gap-4 pt-2">
          <TitleValueWidget
            title="Arrival Date"
            value={
              tradeDetailsById?.arlDate
                ? moment(tradeDetailsById?.arlDate).format("DD-MMM-YYYY")
                : ""
            }
            classes="w-[30%]"
          />

          <TitleValueWidget
            title="Paid To"
            value={tradeDetailsById?.freightDtls?.paidTo ?? "-"}
            classes="w-[30%]"
          />

          <TitleValueWidget
            title="Payment Date"
            value={
              tradeDetailsById?.freightDtls?.date
                ? moment(tradeDetailsById?.freightDtls?.date).format(
                  "DD-MMM-YYYY"
                )
                : "-"
            }
            classes="w-[30%]"
          />
        </div>

        <div className="pt-2 border-b"></div>

        <div className="flex w-full gap-4 pt-2">
          <TitleValueWidget
            title="Payment Type"
            value={tradeDetailsById?.freightDtls?.pmtType ?? ""}
            classes="w-[30%]"
          />

          <TitleValueWidget
            title="Payment Mode"
            value={tradeDetailsById?.freightDtls?.pmtMode ?? ""}
            classes="w-[30%]"
          />
        </div>

        <div className="pt-2 border-b"></div>

        {/* this is where i want labour charges BE Changes */}
        {tradeDetailsById?.tradeMode === 'ORDER' && (
          <>
            <div className="flex w-full gap-4 pt-2">
              <TitleValueWidget
                title="Actual Amount Paid"
                value={tradeDetailsById?.freightDtls?.paidTo === 'ONO' ?
                  getCurrencyNumberWithSymbol(amount) :
                  getCurrencyNumberWithSymbol(actualPaid, true)}
                classes="w-[30%]"
              />

              <TitleValueWidget
                title="Labour Charges"
                value={getCurrencyNumberWithSymbol(tradeDetailsById?.lbrCharges, true)}
                classes="w-[30%]"
              />
            </div>
            <div className="pt-2 border-b"></div>
          </>
        )}

        <div className="pt-2">
          <TitleValueWidget
            title="Comments"
            value={tradeDetailsById?.freightDtls?.comments ?? "-"}
            classes="w-[100%]"
          />
        </div>

        <div className="pt-2 border-b"></div>

        <div className="flex flex-col pt-2">
          <>
            <div className="pb-2 flex gap-4 overflow-x-auto hide-scroll-bar">
              <DocumentsComponent
                title="Uploaded Documents"
                documents={
                  tradeDetailsById?.images.filter(
                    (doc) => doc.type === "TRANSPORT_PAYMENT"
                  ) || []
                }
                className="w-full"
              />
            </div>
          </>
        </div>
      </div>

      {tradeDetailsById?.freightDtls?.pmtStatus === "PENDING" && tradeDetailsById?.freightDtls?.paidTo !== 'ONO' && (
        <ConfirmReceiptArrival />
      )}
    </>
  );
};
export default TransportPmtHistoty;
